import React from 'react';

import { useMantineTheme } from '@mantine/core';

interface Props {
    size?: number;
    color?: string;
    dimmed?: boolean;
}

export const CCC = ({ size = 32, color = 'currentColor', dimmed = false }: Props) => {
    const theme = useMantineTheme();

    const stroke = dimmed ? theme.colors.gray[5] : color;

    return (
        <svg width={size} height={size} viewBox="0 0 240 200" fill="none" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="120" cy="100" rx="115" ry="90" stroke={stroke} strokeWidth="7" />
            <path d="M 100,56 a 41, 43.5, 0, 0, 0, 1, 87" stroke={stroke} strokeWidth="16" />
            <path
                d="M 100,56 a 41, 43.5, 0, 0, 0, 1, 87"
                stroke={stroke}
                strokeWidth="16"
                transform="translate(38 0)"
            />
            <path
                d="M 100,56 a 41, 43.5, 0, 0, 0, 1, 87"
                stroke={stroke}
                strokeWidth="16"
                transform="translate(76 0)"
            />
        </svg>
    );
};
